<app-page-header></app-page-header>
<div class="row">
  <div class="col-lg-6 offset-lg-3">
    <div class="card">
      <div class="card-header">Verify your Identity</div>
                <ng-container *ngIf="show_verify_otp">
                  <ng-container *ngTemplateOutlet="verify_otp_template"></ng-container>
                </ng-container>
                <ng-container *ngIf="show_another_method">
                  <ng-container *ngTemplateOutlet="another_method_template"></ng-container>
                </ng-container>
                <ng-container *ngIf="show_customer_support">
                  <ng-container *ngTemplateOutlet="customer_support_template"></ng-container>
                </ng-container>
    </div>
  </div>

</div>

<ng-template #verify_otp_template>
      <div class="card-body">
        <div class="text-center mb-3">Enter the 6-digit code sent to {{masked_user_otp_method}}</div>
        <form [formGroup]="otpForm" class="d-flex gap-2 justify-content-center">
            <div class="col-auto" *ngFor="let key of controls; let i = index">
              <input
                type="text"
                maxlength="1"
                class="form-control text-center otp-input"
                [formControlName]="key.toString()"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
              />
            </div>
          </form>
          <div class="text-center mb-3">
            <button kendoButton [primary]="true" [disabled]="otpForm.invalid" (click)="verify_otp()"> Verify your code</button>
          </div>
          <div class="text-center mb-3">Your verification code expires in {{(otp_ttl_seconds / 60) | number:'1.0-0' }} mins</div>
          <div class="text-center">
            <button class="btn btn-link" *ngIf="canResend" (click)="resend_otp_details()">
              Resend your code
            </button>
            <div *ngIf="!canResend" class="text-muted">
              Didn't receive the code? <span class="resend-timer">You can resend it in :{{ timerValue }}s</span>
            </div>
          </div>
            <div class="text-center">
                 <span>Having Trouble?</span><button class="btn btn-link"  (click)="try_another_method()">Try another method</button>
          </div>
          <nexus-form-result [model]="form_result"></nexus-form-result>

      </div>

</ng-template>


<ng-template #another_method_template>

<div class="card-body">
   <form [formGroup]="another_method_form" class="mb-2">
      <div class="col justify-content-center mb-3">
     <label class="col-form-label">Choose another way to get your code</label>
       <nexus-form-row control_id="retrieval-wait-input">
            <div class="d-flex flex-row align-items-center flex-wrap">
              <input type="radio" formControlName="mfa_method" value="Email">
              <div class="m-1">
                  <fa-icon [icon]="faEnvelope"> </fa-icon> Email to {{otp_info_model?.masked_user_email}}
              </div>
          </div>
        </nexus-form-row>
          <nexus-form-row control_id="retrieval-wait-input" *ngIf="otp_info_model?.masked_user_phone">
            <div class="d-flex flex-row align-items-center flex-wrap">
              <input type="radio" formControlName="mfa_method" value="SMS">
              <div class="m-1">
                  <fa-icon [icon]="faPhone"> </fa-icon> SMS to {{otp_info_model.masked_user_phone}}
              </div>
          </div>
        </nexus-form-row>
         <div class="row justify-content-center gap-2">
            <button kendoButton (click)="resend_otp_another_method()" class="btn btn-primary me-2" [primary]="true">Send</button>
            <button kendoButton (click)="otp_another_method_cancel()" class="btn btn-primary">Cancel</button>
         </div>
         <nexus-form-result [model]="form_result"></nexus-form-result>
         </div>
   </form>
</div>


</ng-template>

<ng-template #customer_support_template>
  <div class="card-body">
    <div class="col-form-label text-start mb-3">Choose another way to get your code</div>
    <div class="text-start mb-3">
      Only your primary email is available for receiving codes. To add another method and log-in, please contact <b>your
        Account Manager</b> or <a class="grid-link" target="_blank" href="https://www.simplebills.com/support/">Simple
        Bills Customer Support</a>.
    </div>
  </div>
</ng-template>
